import { createSignal, type JSX } from 'solid-js';
import { t } from '../i18n';
import { ConfirmDialog } from './ConfirmDialog';
import { Button } from './ui/Button';

// Retire an ask that went away. Presenter — the confirm gate is a RENDERING
// concern, so it lives with the button rather than as a slot of route state that
// every card would have to key by id.
//
// IT CONFIRMS, and answering does not, because the two acts differ in what a
// mistake costs. An answer is typed prose the author read before sending, and a
// blocker answered by mistake at least leaves triage something to judge.
// Withdrawing closes the row with nothing behind it: no surface re-opens a
// blocker, so the question a run stopped for is simply gone, and the next
// identical ask reads as a first offence. That is the `artifacts.delete` shape —
// one click, unrecoverable from this screen.

export function BlockerWithdrawButton(props: {
  readonly busy: boolean;
  readonly onWithdraw: () => void;
}): JSX.Element {
  const [asking, setAsking] = createSignal(false);

  return (
    <>
      <Button variant="ghost" size="sm" disabled={props.busy} onClick={() => setAsking(true)}>
        {t('blockers.withdraw')}
      </Button>
      <ConfirmDialog
        open={asking()}
        title={t('blockers.withdraw_title')}
        desc={t('blockers.withdraw_desc')}
        cancelLabel={t('blockers.withdraw_cancel')}
        actionLabel={t('blockers.withdraw_confirm')}
        destructive
        onCancel={() => setAsking(false)}
        onConfirm={() => {
          setAsking(false);
          props.onWithdraw();
        }}
      />
    </>
  );
}
